import { render, staticRenderFns } from "./studentPay.vue?vue&type=template&id=eb5d61b6&scoped=true&"
import script from "./studentPay.vue?vue&type=script&lang=js&"
export * from "./studentPay.vue?vue&type=script&lang=js&"
import style0 from "./studentPay.vue?vue&type=style&index=0&id=eb5d61b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5d61b6",
  null
  
)

export default component.exports